import { useEffect, useState } from "react";
import { Sparkle, Phone, ChatCircleDots } from "@phosphor-icons/react";
import { useConcierge } from "@/context/ConciergeContext";
import { useChat } from "@/context/ChatContext";
import { NAP } from "@/data/site";
import { track } from "@/lib/api";

// Floating, contextual concierge + call launcher. Appears after first scroll.
export function StickyQuote() {
  const { openConcierge } = useConcierge();
  const { openChat } = useChat();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-4 right-4 z-40 flex flex-col items-end gap-3 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      data-testid="sticky-quote"
    >
      <button
        onClick={() => {
          track("cta_click", { cta: "open_chatbot", location: "sticky" });
          openChat();
        }}
        aria-label="Ask the MRE assistant"
        data-testid="sticky-chatbot"
        className="grid place-items-center w-12 h-12 bg-card border border-border text-foreground hover:border-primary hover:text-primary transition-colors shadow-lg"
      >
        <ChatCircleDots size={20} />
      </button>
      <a
        href={`tel:${NAP.phoneHref}`}
        onClick={() => track("click_to_call", { location: "sticky" })}
        aria-label={`Call ${NAP.phoneDisplay}`}
        data-testid="sticky-call"
        className="grid place-items-center w-12 h-12 bg-card border border-border text-foreground hover:border-primary hover:text-primary transition-colors shadow-lg"
      >
        <Phone size={20} />
      </a>
      <button
        onClick={() => {
          track("cta_click", { cta: "open_concierge", location: "sticky" });
          openConcierge();
        }}
        data-testid="sticky-concierge"
        className="inline-flex items-center gap-2.5 bg-primary text-primary-foreground font-mono-tech text-xs tracking-widest uppercase px-5 h-12 hover:bg-[hsl(16,100%,55%)] transition-colors shadow-lg"
      >
        <Sparkle size={18} weight="fill" /> Instant Estimate
      </button>
    </div>
  );
}
